import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { getTranslation } from '../data/translations';

const ServicesSection = () => {
  const { language } = useLanguage();
  const navigate = useNavigate();

  const services = [
    { id: 1, title: getTranslation(language, 'buildings'), color: '#EF4444', to: '/services/construction-maison' },
    { id: 2, title: getTranslation(language, 'publicDevelopments'), color: '#10B981', to: '/services/construction-immeuble' },
    { id: 3, title: getTranslation(language, 'energyInfrastructure'), color: '#FF8C00', to: '/services/infrastructures-energetiques' },
    { id: 4, title: getTranslation(language, 'renovation'), color: '#702963', to: '/services/renovation' }
  ];

  const handleClick = (service) => {
    if (service.to) navigate(service.to);
  };

  return (
    <section className="bg-white py-8" data-testid="services-section">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-0">
          {services.map((service) => (
            <button
              key={service.id}
              type="button"
              onClick={() => handleClick(service)}
              className="group relative h-72 overflow-hidden cursor-pointer text-left focus:outline-none focus:ring-2 focus:ring-orange-400"
              style={{ backgroundColor: service.color }}
              data-testid={`service-card-${service.id}`}
            >
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-300" />
              <div className="relative h-full w-full flex items-center justify-center p-8">
                <h3 className="text-white text-center font-bold text-2xl tracking-wide whitespace-pre-line transform group-hover:scale-110 transition-transform duration-300">
                  {service.title}
                </h3>
              </div>
              <div className="absolute bottom-0 left-0 right-0 h-1 bg-white transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300" />
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
